// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAiFJheOl5jqmj7Z7OQljVi-0FCTIzms-8",
  authDomain: "mainstreet-carwash.firebaseapp.com",
  projectId: "mainstreet-carwash",
  storageBucket: "mainstreet-carwash.firebasestorage.app",
  messagingSenderId: "451734386413",
  appId: "1:451734386413:web:74b34401f5037458c43ee4",
  measurementId: "G-HT2Z10TD38"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore and Auth
export const db = getFirestore(app);
export const auth = getAuth(app);
